
export default [
  {
    path: '/information',
    name: '更多资讯',
    component: () => import ( /* webpackChunkName: "userEdit" */ `@/views/pub/information/information.vue`)
  },
  {
    path: '/guide',
    name: '系统操作指南',
    component: () => import ( /* webpackChunkName: "userEdit" */ `@/views/pub/guide/guide.vue`)
  },
  {
    path: '/info',
    name: '咨询详情',
    component: () => import ( /* webpackChunkName: "userEdit" */ `@/views/pub/information/info.vue`)
  },
  // {
  //   path: 'person/edit',
  //   name: '雇员基础信息修改',
  //   component: () => import ( /* webpackChunkName: "userEdit" */ `@/views/pub/user/userEdit`)
  // },
  {
    path: '/account/getAccountInfo.action',
    name: '雇员基础信息修改',
    component: () => import ( /* webpackChunkName: "userEdit" */ `@/views/pub/pubIndex.vue`)
  },
  {
    path: '/per/perEntryList.action',
    name: '待入职',
    component: () => import ( `@/views/pub/pubIndex.vue`),
  },
  {
    path: '/sys/msgTabs',
    name: '消息中心',
    component: () => import ( /* webpackChunkName: "userEdit" */ `@/views/pub/message/msgTabs`)
  },
];
